export const LoadingOverlay = () => (
  <div className="absolute inset-0 z-50 flex items-center justify-center bg-gray-50/30 backdrop-blur-sm">
    <div className="rounded-lg bg-white p-4 shadow-lg">
      <div className="mx-auto h-8 w-8 animate-spin rounded-full border-b-2 border-gray-500" />
    </div>
  </div>
);
